import {Directive, Input} from '@angular/core';
import {PredictionModelDto} from '@sharedrest/data.restservice';

@Directive({selector: '[variableValuePredictionModelValue]'})
export class VariableValuePredictionModelValueDirective {
  @Input() variableValuePredictionModelValue: any;
  @Input() entity: PredictionModelDto;
}
